import { type ArtifactType } from '@app/client/common/structs/nft/artifacts';

type translationKeType = 'label' | 'twitter' | 'twitter_uncollected';

export function getTranslationByArtifactKey(t, artifactKey: ArtifactType, translationKey: translationKeType = 'label') {
    return t(`${translationKey}_${artifactKey.toLowerCase()}`);
}
